// Meilleure position GPS en quelques secondes : on écoute les mesures successives et on garde la plus précise.
export const meilleurePosition = ({ dureeMs = 10000, precisionCible = 20 } = {}) => new Promise((resolve) => {
  if (!('geolocation' in navigator)) return resolve({ erreur: 'indisponible' });
  let best = null;
  let fini = false;
  let watchId = null;
  const terminer = (res) => {
    if (fini) return;
    fini = true;
    clearTimeout(timer);
    if (watchId !== null) navigator.geolocation.clearWatch(watchId);
    resolve(res || (best ? best : { erreur: 'delai' }));
  };
  const timer = setTimeout(() => terminer(), dureeMs);
  watchId = navigator.geolocation.watchPosition(
    (pos) => {
      const p = { lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: Math.round(pos.coords.accuracy || 0) };
      if (!best || p.accuracy < best.accuracy) best = p;
      if (best.accuracy && best.accuracy <= precisionCible) terminer(best);
    },
    (err) => { if (err.code === 1) terminer({ erreur: 'refus' }); else if (!best && err.code !== 3) terminer({ erreur: 'indisponible' }); },
    { enableHighAccuracy: true, timeout: dureeMs, maximumAge: 0 }
  );
});

export const MESSAGE_ERREUR_GPS = {
  refus: 'localisation refusée par le navigateur (autorisez-la dans les réglages du site)',
  indisponible: 'localisation indisponible sur cet appareil',
  delai: 'position introuvable dans le temps imparti',
};
